import { useEffect, useState } from 'react';

const ROTATING = ['쇼핑몰', '브랜드', 'D2C 스토어', 'e커머스'];

export default function HeroSection() {
  const [idx, setIdx] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setIdx(p => (p + 1) % ROTATING.length);
        setVisible(true);
      }, 300);
    }, 2500);
    return () => clearInterval(interval);
  }, []);

  const scrollToContact = () =>
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });

  return (
    <section id="home" className="relative flex flex-col items-center overflow-hidden bg-black pt-[185px] pb-14 md:min-h-[100svh] md:justify-center md:pt-[215px] md:pb-0">
      {/* Subtle grid */}
      <div className="absolute inset-0 pointer-events-none"
        style={{ backgroundImage: 'linear-gradient(rgba(255,255,255,0.025) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.025) 1px, transparent 1px)', backgroundSize: '60px 60px' }} />
      {/* Neon glow center */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[500px] rounded-full bg-[#00FF87]/4 blur-[180px] pointer-events-none" />

      <div className="relative z-10 w-full max-w-6xl mx-auto px-5 md:px-8 text-center">

        {/* Problem badge */}
        <div className="inline-flex items-center gap-2 border border-white/10 rounded-full px-3 py-1.5 md:px-5 md:py-2.5 mb-5 md:mb-10 bg-white/3">
          <span className="w-1.5 h-1.5 md:w-2 md:h-2 rounded-full bg-[#FF4D4D] animate-pulse inline-block flex-shrink-0"></span>
          <span className="text-white/50 text-[10px] md:text-sm leading-relaxed whitespace-nowrap">
            지금 이 순간에도 광고비가 낭비되고 있습니다
          </span>
        </div>

        {/* Main question */}
        <div className="mb-3 md:mb-3">
          <p className="text-white/30 font-medium tracking-tight text-sm md:text-xl lg:text-2xl leading-relaxed">
            광고비만 쓰고<br className="block md:hidden" />계신가요?
          </p>
        </div>

        {/* Giant headline */}
        <div className="mb-5 md:mb-4" style={{ lineHeight: 1.0 }}>
          <div className="font-black text-white"
            style={{ fontSize: 'clamp(2.6rem, 12vw, 9rem)', fontFamily: "'Space Grotesk', 'Noto Sans KR', sans-serif", letterSpacing: '-0.03em' }}>
            우리는
          </div>
          {/* Rotating industry */}
          <div className="flex items-center justify-center gap-2 md:gap-4 my-2 md:my-2">
            <div className="h-0.5 md:h-1 flex-1 max-w-[60px] md:max-w-[180px] bg-gradient-to-r from-transparent to-[#00FF87]/40 rounded-full" />
            <div
              className="font-black transition-all duration-300"
              style={{
                fontSize: 'clamp(1.3rem, 6vw, 4.5rem)',
                fontFamily: "'Space Grotesk', 'Noto Sans KR', sans-serif",
                color: '#00FF87',
                opacity: visible ? 1 : 0,
                transform: visible ? 'translateY(0)' : 'translateY(-10px)',
              }}>
              {ROTATING[idx]}
            </div>
            <div className="h-0.5 md:h-1 flex-1 max-w-[60px] md:max-w-[180px] bg-gradient-to-l from-transparent to-[#00FF87]/40 rounded-full" />
          </div>
          <div className="font-black text-white"
            style={{ fontSize: 'clamp(2.6rem, 12vw, 9rem)', fontFamily: "'Space Grotesk', 'Noto Sans KR', sans-serif", letterSpacing: '-0.03em' }}>
            매출을
          </div>
          <div className="font-black"
            style={{
              fontSize: 'clamp(2.6rem, 12vw, 9rem)',
              fontFamily: "'Space Grotesk', 'Noto Sans KR', sans-serif",
              letterSpacing: '-0.03em',
              color: '#00FF87',
              textShadow: '0 0 100px rgba(0,255,135,0.5), 0 0 200px rgba(0,255,135,0.2)',
            }}>
            만듭니다
          </div>
        </div>

        {/* Proof badges */}
        <div className="flex items-center justify-center gap-2 md:gap-3 mb-7 md:mb-12 flex-wrap">
          <div className="flex items-center gap-1 md:gap-2 bg-white/5 border border-white/8 rounded-full px-3 py-1.5 md:px-5 md:py-2.5">
            <span className="font-black text-white/35 text-xs md:text-lg leading-none" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>4.8억</span>
            <span className="text-white/20 text-xs">→</span>
            <span className="font-black text-[#00FF87] text-xs md:text-lg leading-none" style={{ fontFamily: "'Space Grotesk', sans-serif", textShadow: '0 0 20px rgba(0,255,135,0.5)' }}>20.1억</span>
            <span className="text-white/30 text-xs ml-0.5 md:ml-1 hidden sm:inline">4개월</span>
          </div>
          <div className="flex items-center gap-1 md:gap-2 bg-white/5 border border-white/8 rounded-full px-3 py-1.5 md:px-5 md:py-2.5">
            <span className="font-black text-[#00FF87] text-xs md:text-lg leading-none">+318%</span>
            <span className="text-white/30 text-xs hidden sm:inline">매출 성장</span>
          </div>
          <div className="flex items-center gap-1 md:gap-2 bg-white/5 border border-white/8 rounded-full px-3 py-1.5 md:px-5 md:py-2.5">
            <span className="font-black text-white text-xs md:text-lg leading-none">350+</span>
            <span className="text-white/30 text-xs hidden sm:inline">브랜드 성공</span>
          </div>
        </div>

        {/* THE CTA */}
        <div className="flex flex-col items-center gap-4 md:gap-4">
          <button
            onClick={scrollToContact}
            className="group relative inline-flex items-center gap-2 md:gap-3 bg-[#00FF87] hover:bg-[#00e87a] text-black font-black text-sm md:text-xl px-7 py-4 md:px-14 md:py-6 rounded-xl md:rounded-2xl transition-all duration-200 cursor-pointer whitespace-nowrap overflow-hidden w-full sm:w-auto justify-center"
            style={{ boxShadow: '0 0 60px rgba(0,255,135,0.35), 0 0 120px rgba(0,255,135,0.1)' }}
          >
            <span className="relative z-10">광고 진단 무료로 받기</span>
            <i className="ri-arrow-right-line text-lg md:text-xl relative z-10 group-hover:translate-x-1 transition-transform"></i>
          </button>
          <div className="flex items-center gap-4 md:gap-6 flex-wrap justify-center">
            {['상담 비용 0원', '계약 강요 없음', '24시간 내 응답'].map((t, i) => (
              <span key={i} className="flex items-center gap-1.5 md:gap-1.5 text-white/30 text-xs leading-relaxed">
                <i className="ri-check-line text-[#00FF87]/60 text-xs flex-shrink-0"></i>
                {t}
              </span>
            ))}
          </div>
        </div>

        {/* Scroll indicator */}
        <div className="mt-10 md:mt-12 flex flex-col items-center gap-2 md:gap-2 text-white/20 text-xs pb-0 md:pb-8 leading-relaxed">
          <span>스크롤해서<br className="block md:hidden" />성과 확인</span>
          <i className="ri-arrow-down-line text-base md:text-lg animate-bounce"></i>
        </div>
      </div>
    </section>
  );
}
